import React from 'react';
import { styled } from '@ff/ui';
import SkeletonLoader from '@ff/ui/Skeleton/SkeletonLoader';

export default function HeroLandingLoader() {
  return (
    <Container>
      <ImageLoader>
        <SkeletonLoader variant="rectangular" height="100%" width="100%" />
      </ImageLoader>
      <TextLoader>
        <SkeletonLoader variant="text" />
        <SkeletonLoader variant="text" />
        <SkeletonLoader variant="text" />
        <SkeletonLoader variant="text" />
      </TextLoader>
      <ImageLoader>
        <SkeletonLoader variant="rectangular" height="100%" width="100%" />
      </ImageLoader>
    </Container>
  );
}

const Container = styled.Box(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  justifyContent: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: theme.maxWidth,
  padding: '36px 36px 72px 36px',
}));

const TextLoader = styled.Box(({ theme }) => ({
  margin: '36px',
  padding: '0 36px',
  width: '100%',
  [theme.mediaQueries.sm]: {
    padding: '0',
    width: '50%',
  },
}));

const ImageLoader = styled.Box(({ theme }) => ({
  height: '192px',
  width: '100%',
  [theme.mediaQueries.sm]: {
    height: '300px',
    width: '64%',
  }
}));
